import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn'

/** A glass surface. Do not nest panels: one level of glass per region. */
export function Panel({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('glass overflow-hidden rounded-[var(--radius-panel)]', className)} {...props}>
      {children}
    </div>
  )
}

export function PanelHeader({ title, description, actions, className }: { title: ReactNode; description?: ReactNode; actions?: ReactNode; className?: string }) {
  return (
    <div className={cn('flex items-start justify-between gap-4 px-5 pb-3 pt-4', className)}>
      <div className="min-w-0">
        <h3 className="text-[length:calc(14px*var(--text-scale))] font-semibold text-fg">{title}</h3>
        {description && <p className="mt-0.5 text-[length:calc(12.5px*var(--text-scale))] text-muted">{description}</p>}
      </div>
      {actions}
    </div>
  )
}

export function DescriptionList({ items, className }: { items: { label: ReactNode; value: ReactNode }[]; className?: string }) {
  return (
    <dl className={cn('grid grid-cols-[minmax(110px,34%)_1fr] gap-x-4 gap-y-2.5 text-[length:calc(13.5px*var(--text-scale))]', className)}>
      {items.map((item, index) => (
        <div key={index} className="contents">
          <dt className="text-muted">{item.label}</dt>
          <dd className="min-w-0 break-words text-fg">{item.value}</dd>
        </div>
      ))}
    </dl>
  )
}
